const voicemailGreetingScamDeterrent = {
  slug: 'voicemail-greeting-scam-deterrent',
  title: 'Voicemail greetings that deter scammers',
  description:
    'Tips for a professional voicemail that gives less away to scammers and wrong-number dialers.',
  category: 'guides',
  guideType: 'tips',
  readMinutes: 3,
  partnerTip: 'none',
  relatedSlugs: ['managing-unwanted-calls', 'protecting-yourself-phone-scams-australia'],
  sections: [
    {
      type: 'paragraph',
      text: 'Your greeting is often played to unknown callers — including scammers testing active numbers.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'What to avoid',
    },
    {
      type: 'list',
      items: [
        'Full name plus date of birth hints (“Hi, it’s John, sorry I missed you on my 50th…”)',
        '“I’m overseas” or long absence messages — signals an empty home',
        'Confirming you will call unknown numbers back urgently',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Safer patterns',
    },
    {
      type: 'list',
      items: [
        'Short, neutral: “Please leave a message and I’ll return your call.”',
        'No promise to return calls to sales or unknown businesses',
        'Optional: “If this is urgent, contact me through [known channel]” for family only',
      ],
    },
    {
      type: 'tip',
      text: 'Let unknown callers go to this greeting while you search the number on WhoDatNumber before calling back.',
    },
    {
      type: 'lookupCta',
    },
  ],
};

export default voicemailGreetingScamDeterrent;

